export default "__VITE_ASSET__mmQy9VIN__"